import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { PBold, PThin } from '../../../theme/typography';
import { Input } from '../../../lib/ui/form_elements/RadioButton/css';
import {
  Card,
  InfoRow,
  TitleRow,
  Body,
  CostBreakdown,
  CostItem,
  RateCardContainer,
  Head,
} from './css';

const RateCard = ({
  options, input, current, putReduxServiceLevelCode, readOnly = false, serviceLevels, page,
}) => {
  const handleChange = (event) => {
    input.onChange(event);
    putReduxServiceLevelCode(event.target.value);
  };

  return (
    <RateCardContainer>
      {options.length !== 0
        ? (options.map(({
          label, value, totalCharges, totalChargesValue, charges, tax, taxValue, expDate, totalAmount,
          defaultOption, toBeHidden, totalAmountCurrencyCode, isApproved,
        }, index) => (
          !toBeHidden && (
          <Card
            key={index}
            height="auto"
            className={((current === value) ? 'selected' : '') + (readOnly ? ' readOnly' : '')}
          >
            <Head>
              {!readOnly
                ? (
                  <TitleRow>
                    <Input
                      {...input}
                      type="radio"
                      value={value}
                      checked={defaultOption}
                      onChange={(event) => handleChange(event)}
                    />
                    <PBold className="large">{label}</PBold>
                  </TitleRow>
                )
                : (
                  <InfoRow>
                    <PBold>{t('Service Level')}</PBold>
                    <PThin>{label}</PThin>
                  </InfoRow>
                )}
            </Head>
            {/* {noServicesAvailable ? (
              <Body>
                <InfoRow>
                  <PThin>{page === 'create-quote' ? t('NoQuoteAvailable') : t('NoServicesAvailable')}</PThin>
                </InfoRow>
              </Body>
            ) : ( */}
            <Body>
              {expDate && (
                <InfoRow>
                  <PBold>{t('EstDelivery')}</PBold>
                  <PThin>{expDate}</PThin>
                </InfoRow>
              )}
              <CostBreakdown>
                {totalChargesValue > 0 && isApproved
                && (
                  <>
                    <CostItem key="tcharges">
                      <PThin className="small">{t('TotalCharges')}</PThin>
                      <PThin className="small">{totalCharges}</PThin>
                    </CostItem>
                    {charges.map(({ amount, description, amountValue }, index) => (amountValue > 0 && (
                      <CostItem key={index}>
                        <PThin className="small capitalize">{description && description.toLowerCase()}</PThin>
                        <PThin className="small">{amount}</PThin>
                      </CostItem>
                    )
                    ))}
                    {taxValue > 0 && (
                    <CostItem key="tax">
                      <PThin className="small">{t('Tax')}</PThin>
                      <PThin className="small">{tax}</PThin>
                    </CostItem>
                    )}
                  </>
                )}
              </CostBreakdown>
              {totalChargesValue === 0 || !isApproved
                ? page === 'create-quote'
                  ? (
                    <InfoRow>
                      <PThin>{t('ZeroTotalPriceQuote1')}</PThin>
                      <PBold>{t('ZeroTotalPriceQuote2')}</PBold>
                      <PThin>{t('ZeroTotalPriceQuote3')}</PThin>
                    </InfoRow>
                  )
                  : page === 'create-shipment'
                    ? (
                      <InfoRow>
                        <PThin>{t('ZeroTotalPriceShipment')}</PThin>
                      </InfoRow>
                    )
                    : null
                : (
                  <>
                    <hr />
                    <CostItem>
                      <PBold>{t('TotalPrice')}</PBold>
                      <PBold>
                        {totalAmount}
                        {' '}
                        {totalAmountCurrencyCode}
                      </PBold>
                    </CostItem>
                  </>
                )}
            </Body>
            {/* )} */}
          </Card>
          )
        )))
        : (
          <Card
            key={1}
            height="auto"
            className="selected"
          >
            <Head>
              <TitleRow>
                <Input
                  {...input}
                  type="radio"
                  checked
                />
                <PBold className="large">{serviceLevels.description}</PBold>
              </TitleRow>
            </Head>
            <Body>
              {page === 'create-quote'
                ? (
                  <InfoRow>
                    <PThin>{t('ZeroTotalPriceQuote1')}</PThin>
                    <PBold>{t('ZeroTotalPriceQuote2')}</PBold>
                    <PThin>{t('ZeroTotalPriceQuote3')}</PThin>
                  </InfoRow>
                )
                : page === 'create-shipment'
                  ? (
                    <InfoRow>
                      <PThin>{t('ZeroTotalPriceShipment')}</PThin>
                    </InfoRow>
                  )
                  : null }
            </Body>
          </Card>
        )}
    </RateCardContainer>
  );
};

RateCard.propTypes = {
  options: PropTypes.array,
  input: PropTypes.object,
  current: PropTypes.string,
  putReduxServiceLevelCode: PropTypes.func,
  readOnly: PropTypes.bool,
  serviceLevels: PropTypes.string,
  totalAmountValue: PropTypes.number,
  page: PropTypes.string,
};

export default RateCard;
